import { DirectiveEpisodeModule } from './episode/directive/directive-episode.module';
import { DirectiveCourseModule } from './course/directive/directive-course.module';
import { DirectiveMissionModule } from './mission/directive/directive-mission.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ByocPopupEpisodeModule } from './episode/episode.module';
import { ByocPopupCourseModule } from './course/course.module';
import { ByocPopupMissionModule } from './mission/mission.module';

@NgModule({
    imports: [
        CommonModule,
        DirectiveMissionModule,
        DirectiveCourseModule,
        DirectiveEpisodeModule,
        ByocPopupEpisodeModule,
        ByocPopupCourseModule,
        ByocPopupMissionModule,
    ],
    declarations: [],
    exports: [DirectiveMissionModule, DirectiveCourseModule, DirectiveEpisodeModule, ByocPopupEpisodeModule, ByocPopupCourseModule, ByocPopupMissionModule],
})
export class ByocPopupModule {}
